export default "__VITE_ASSET__DlfGrO4S__"